// UI translations DE/EN/TR
export const LANGS = [
  { code: "de", label: "DE", full: "Deutsch" },
  { code: "en", label: "EN", full: "English" },
  { code: "tr", label: "TR", full: "Türkçe" },
];

export const DEFAULT_LANG = "de";

export const t = (key, lang) => {
  const dict = TRANSLATIONS[key];
  if (!dict) return key;
  return dict[lang] || dict[DEFAULT_LANG] || key;
};

export const TRANSLATIONS = {
  // Nav
  "nav.beauty": { de: "Beauty", en: "Beauty", tr: "Beauty" },
  "nav.hair": { de: "Hair", en: "Hair", tr: "Hair" },
  "nav.about": { de: "Über uns", en: "About", tr: "Hakkımızda" },
  "nav.contact": { de: "Kontakt", en: "Contact", tr: "İletişim" },
  "nav.book": { de: "Termin buchen", en: "Book now", tr: "Randevu al" },
  "nav.book_phone": { de: "Telefonisch buchen", en: "Call to book", tr: "Telefonla ara" },
  "nav.menu": { de: "Menü", en: "Menu", tr: "Menü" },

  // Hero (home)
  "hero.tagline": {
    de: "Friseur · Kosmetik",
    en: "Hair · Beauty",
    tr: "Kuaför · Güzellik",
  },
  "hero.title_1": { de: "Wo Ästhetik", en: "Where beauty", tr: "Estetiğin" },
  "hero.title_2": { de: "auf", en: "meets", tr: "doğallıkla" },
  "hero.title_3": { de: "Natürlichkeit", en: "nature", tr: "buluştuğu" },
  "hero.title_4": { de: "trifft.", en: ".", tr: "yer." },
  "hero.subtitle": {
    de: "Im Studio von Nava verbinden wir Friseur-Handwerk, ästhetische Behandlungen und Kosmetik unter einem Dach — mit Kompetenz, Beratung und Gespür für Natürlichkeit.",
    en: "At Nava Studio we combine hairdressing craft, aesthetic treatments and cosmetics under one roof — with expertise, honest advice and a feeling for natural results.",
    tr: "Nava stüdyosunda kuaförlük, estetik uygulamalar ve kozmetik hizmetleri tek çatı altında birleşiyor — deneyim, samimi danışmanlık ve doğallık anlayışıyla.",
  },
  "hero.subtitle_nava": { de: "Nava", en: "Nava", tr: "Nava" },
  "hero.cta_book": { de: "Termin buchen", en: "Book appointment", tr: "Randevu al" },
  "hero.cta_services": { de: "Leistungen entdecken", en: "Explore services", tr: "Hizmetleri keşfet" },
  "hero.meta_1": { de: "Hair Salon", en: "Hair Salon", tr: "Kuaför" },
  "hero.meta_2": { de: "Ästhetik & Kosmetik", en: "Aesthetics & Beauty", tr: "Estetik & Güzellik" },
  "hero.meta_3": { de: "Premium Studio Frankfurt", en: "Premium Studio Frankfurt", tr: "Premium Stüdyo Frankfurt" },
  "hero.est": { de: "Est. Frankfurt", en: "Est. Frankfurt", tr: "Frankfurt" },

  // Services (home)
  "services.overline": { de: "Behandlungen · Pricing", en: "Treatments · Pricing", tr: "Tedaviler · Fiyatlar" },
  "services.title_1": {
    de: "Eine kuratierte Auswahl",
    en: "A curated selection of",
    tr: "Özenle seçilmiş",
  },
  "services.title_em": { de: "präziser", en: "precise", tr: "hassas" },
  "services.title_2": {
    de: "Behandlungen.",
    en: "treatments.",
    tr: "uygulamalar.",
  },
  "services.description": {
    de: "Von medizinischer Ästhetik über klassische Kosmetik bis zur Nagelmodellage — jede Anwendung individuell auf Sie abgestimmt.",
    en: "From medical aesthetics to classic cosmetics and nail design — every treatment tailored to you.",
    tr: "Medikal estetikten klasik kozmetiğe ve tırnak modellemeye kadar — her uygulama size özel.",
  },
  "services.book_for": { de: "Termin für", en: "Book", tr: "Randevu:" },

  // Friseur Promo
  "friseur_promo.badge": { de: "Neu im Studio", en: "New at the studio", tr: "Stüdyoda yeni" },
  "friseur_promo.overline": { de: "Hair Salon", en: "Hair Salon", tr: "Kuaför" },
  "friseur_promo.title_1": { de: "Damen · Herren ·", en: "Ladies · Gents ·", tr: "Bayan · Bay ·" },
  "friseur_promo.title_em": { de: "Kinder", en: "Kids", tr: "Çocuk" },
  "friseur_promo.description": {
    de: "Unsere Friseurin verwöhnt Sie mit präzisen Schnitten, eleganter Farbe, Strähnen, Keratin-Behandlung und Braut-Styling.",
    en: "Our hairdresser pampers you with precise cuts, elegant color, highlights, keratin treatments and bridal styling.",
    tr: "Kuaförümüz; hassas kesim, zarif renk, röfle, keratin bakımı ve gelin stili hizmetleriyle sizi şımartıyor.",
  },
  "friseur_promo.phone_note": {
    de: "Telefonisch oder per WhatsApp · +49 177 1815027",
    en: "By phone or WhatsApp · +49 177 1815027",
    tr: "Telefon veya WhatsApp · +49 177 1815027",
  },
  "friseur_promo.cta": { de: "Friseur entdecken", en: "Discover Hair Salon", tr: "Kuaförü keşfet" },
  "friseur_promo.col_1": { de: "Damen", en: "Ladies", tr: "Bayan" },
  "friseur_promo.col_2": { de: "Herren", en: "Gents", tr: "Bay" },
  "friseur_promo.col_3": { de: "Kinder", en: "Kids", tr: "Çocuk" },

  // About
  "about.overline": { de: "Über uns", en: "About us", tr: "Hakkımızda" },
  "about.title_1": { de: "Zwei Frauen.", en: "Two women.", tr: "İki kadın." },
  "about.title_2": { de: "Ein Anspruch:", en: "One promise:", tr: "Tek söz:" },
  "about.title_em": { de: "Natürlichkeit.", en: "naturalness.", tr: "doğallık." },
  "about.intro": {
    de: "Hair & Beauty Nava ist mehr als ein Studio — es ist die Zusammenarbeit zweier Spezialistinnen, die ihr Handwerk lieben. Bei uns finden Sie Friseur-Expertise und ästhetische Kosmetik unter einem Dach.",
    en: "Hair & Beauty Nava is more than a studio — it is the collaboration of two specialists who love their craft. Under one roof you'll find hairdressing expertise and aesthetic cosmetics.",
    tr: "Hair & Beauty Nava sadece bir stüdyo değil — mesleğini seven iki uzmanın buluşma noktasıdır. Kuaförlük ve estetik kozmetik tek çatı altında.",
  },
  "about.profile_beauty.role": { de: "Beauty · Ästhetik", en: "Beauty · Aesthetics", tr: "Güzellik · Estetik" },
  "about.profile_beauty.name": { de: "Ihre Kosmetikerin", en: "Your Cosmetician", tr: "Kozmetoloğunuz" },
  "about.profile_beauty.text": {
    de: "Als Fachkosmetikerin verbinde ich Erfahrung mit ästhetischer Präzision. Mein Fokus liegt auf sicheren, harmonischen Ergebnissen — von der klassischen Gesichtsbehandlung bis zu individuellen Pflegeritualen. Ich nehme mir Zeit für eine sorgfältige Analyse und berate Sie ehrlich, damit jede Behandlung wirklich zu Ihnen passt.",
    en: "As a professional cosmetician I combine experience with aesthetic precision. My focus is on safe, harmonious results — from classic facials to individual care rituals. I take time for a careful analysis and advise you honestly, so every treatment truly fits you.",
    tr: "Profesyonel kozmetolog olarak deneyimi estetik hassasiyetle birleştiriyorum. Odağım güvenli ve uyumlu sonuçlar — klasik yüz bakımından kişiye özel bakım ritüellerine kadar. Dikkatli bir analiz için zaman ayırır, size dürüst tavsiyeler sunarım.",
  },
  "about.profile_hair.role": { de: "Hair · Friseur", en: "Hair · Salon", tr: "Saç · Kuaför" },
  "about.profile_hair.name": { de: "Unsere Friseurin", en: "Our Hairdresser", tr: "Kuaförümüz" },
  "about.profile_hair.text": {
    de: "Mit jahrelanger Erfahrung im Friseur-Handwerk steht unsere Friseurin für präzise Schnitte, moderne Farbtechniken und individuelle Beratung. Ob Damen-, Herren- oder Kinderschnitt, Strähnen, Keratin-Behandlung oder Braut-Styling — sie hört zu, denkt mit und holt mit ruhiger Hand das Beste aus jedem Haar.",
    en: "With years of hairdressing experience, our hair stylist stands for precise cuts, modern color techniques and individual advice. Whether ladies, gents or kids' cuts, highlights, keratin treatment or bridal styling — she listens, thinks with you and brings out the best in every hair with a steady hand.",
    tr: "Uzun yıllara dayanan kuaförlük deneyimiyle kuaförümüz; hassas kesim, modern renk teknikleri ve kişisel danışmanlık sunar. Bayan, bay veya çocuk kesimi, röfle, keratin veya gelin stili — dinler, düşünür ve her saçtan en iyisini çıkarır.",
  },
  "about.pillar_1.title": { de: "Zwei Handwerke. Ein Studio.", en: "Two crafts. One studio.", tr: "İki zanaat. Tek stüdyo." },
  "about.pillar_1.text": {
    de: "Friseur und ästhetische Kosmetik unter einem Dach — bequem, abgestimmt, persönlich.",
    en: "Hair and aesthetic cosmetics under one roof — convenient, coordinated, personal.",
    tr: "Kuaför ve estetik kozmetik tek çatı altında — pratik, uyumlu, kişisel.",
  },
  "about.pillar_2.title": { de: "Individuelle Beratung", en: "Personal consultation", tr: "Kişisel danışmanlık" },
  "about.pillar_2.text": {
    de: "Jede Behandlung beginnt mit einem ehrlichen Gespräch — von der Hautanalyse bis zur Schnittberatung.",
    en: "Every treatment starts with an honest conversation — from skin analysis to cut consultation.",
    tr: "Her uygulama içten bir sohbetle başlar — cilt analizinden kesim danışmanlığına kadar.",
  },
  "about.pillar_3.title": { de: "Natürliche Ergebnisse", en: "Natural results", tr: "Doğal sonuçlar" },
  "about.pillar_3.text": {
    de: "Wir unterstreichen, was schon da ist — niemals überzeichnen, sondern verfeinern.",
    en: "We enhance what's already there — never overdo, always refine.",
    tr: "Var olanı vurgularız — abartmadan, sadece inceltiriz.",
  },

  // Contact
  "contact.overline": { de: "Kontakt · Besuch", en: "Contact · Visit", tr: "İletişim · Ziyaret" },
  "contact.title_1": { de: "Wir freuen uns auf", en: "We look forward to", tr: "Sizi ağırlamaktan" },
  "contact.title_em": { de: "Ihren Besuch.", en: "your visit.", tr: "mutluluk duyarız." },
  "contact.subtitle": {
    de: "Buchen Sie online Ihren Wunschtermin oder erreichen Sie uns direkt.",
    en: "Book your appointment online or reach us directly.",
    tr: "Randevunuzu online alın veya bize doğrudan ulaşın.",
  },
  "contact.booking_overline": { de: "Online Buchung", en: "Online Booking", tr: "Online Randevu" },
  "contact.booking_title": {
    de: "Reservieren Sie in wenigen Klicks.",
    en: "Reserve in just a few clicks.",
    tr: "Birkaç tıkla randevu alın.",
  },
  "contact.booking_description": {
    de: "Verfügbarkeit prüfen, Behandlung wählen und Termin sofort bestätigen — über unseren Buchungspartner Salonkee.",
    en: "Check availability, choose a treatment and confirm instantly — through our booking partner Salonkee.",
    tr: "Uygunluk kontrolü, uygulama seçimi ve anında onay — Salonkee ortağımız üzerinden.",
  },
  "contact.booking_cta": { de: "Jetzt Termin buchen", en: "Book now", tr: "Şimdi randevu al" },
  "contact.card_studio_label": { de: "Studio", en: "Studio", tr: "Stüdyo" },
  "contact.card_phone_label": { de: "Telefon", en: "Phone", tr: "Telefon" },
  "contact.card_hours_label": { de: "Öffnungszeiten", en: "Opening hours", tr: "Çalışma saatleri" },
  "contact.card_phone_subtitle": { de: "Direktkontakt für Beratung", en: "Direct contact for advice", tr: "Danışma için doğrudan iletişim" },
  "contact.card_route": { de: "Route planen", en: "Get directions", tr: "Yol tarifi" },
  "contact.card_call": { de: "Anrufen", en: "Call", tr: "Ara" },
  "contact.hours_open": { de: "Mo – Do · 09:00 – 19:00", en: "Mon – Thu · 09:00 – 19:00", tr: "Pzt – Prş · 09:00 – 19:00" },
  "contact.hours_closed": { de: "Fr – So · Geschlossen", en: "Fri – Sun · Closed", tr: "Cum – Paz · Kapalı" },

  // Footer
  "footer.tagline": {
    de: "Friseur · Kosmetik — ein Studio in Frankfurt für ganzheitliche Schönheit von Schnitt bis Behandlung.",
    en: "Hair · Beauty — a Frankfurt studio for holistic beauty from cut to treatment.",
    tr: "Kuaför · Güzellik — Frankfurt'ta kesimden bakıma bütüncül güzellik stüdyosu.",
  },
  "footer.studio_label": { de: "Studio", en: "Studio", tr: "Stüdyo" },
  "footer.beauty_label": { de: "Beauty", en: "Beauty", tr: "Beauty" },
  "footer.hair_label": { de: "Hair · Tel / WhatsApp", en: "Hair · Phone / WhatsApp", tr: "Saç · Tel / WhatsApp" },
  "footer.book_overline": { de: "Beauty Termin", en: "Beauty booking", tr: "Beauty randevu" },
  "footer.book_cta": { de: "Online buchen", en: "Book online", tr: "Online randevu" },
  "footer.impressum": { de: "Impressum", en: "Imprint", tr: "Künye" },
  "footer.privacy": { de: "Datenschutz", en: "Privacy", tr: "Gizlilik" },
  "footer.terms": { de: "AGB", en: "Terms", tr: "Şartlar" },

  // Friseur page
  "friseur.hero_overline": { de: "Friseur Studio · Frankfurt", en: "Hair Studio · Frankfurt", tr: "Kuaför Stüdyosu · Frankfurt" },
  "friseur.hero_title_1": { de: "Schnitt mit", en: "A cut with", tr: "Karakterli" },
  "friseur.hero_title_em": { de: "Charakter.", en: "character.", tr: "kesim." },
  "friseur.hero_subtitle": {
    de: "Unsere Friseurin verbindet Handwerk, modernes Styling und Pflege der Extraklasse — für",
    en: "Our hairdresser combines craftsmanship, modern styling and premium care — for",
    tr: "Kuaförümüz zanaatı, modern stili ve premium bakımı birleştiriyor —",
  },
  "friseur.hero_ladies": { de: "Damen", en: "Ladies", tr: "Bayan" },
  "friseur.hero_gents": { de: "Herren", en: "Gents", tr: "Bay" },
  "friseur.hero_kids": { de: "Kinder", en: "Kids", tr: "Çocuk" },
  "friseur.hero_and": { de: "und", en: "and", tr: "ve" },
  "friseur.hero_call": { de: "Anrufen", en: "Call", tr: "Ara" },
  "friseur.hero_whatsapp": { de: "WhatsApp", en: "WhatsApp", tr: "WhatsApp" },
  "friseur.hero_prices": { de: "Preise entdecken", en: "See prices", tr: "Fiyatları gör" },
  "friseur.hero_note": {
    de: "Friseur-Termine ausschließlich telefonisch oder per WhatsApp unter",
    en: "Hair appointments by phone or WhatsApp only at",
    tr: "Kuaför randevuları yalnızca telefon veya WhatsApp ile:",
  },
  "friseur.back": { de: "Zurück zur Startseite", en: "Back to home", tr: "Anasayfaya dön" },
  "friseur.services_overline": { de: "Hair Services · Pricing", en: "Hair Services · Pricing", tr: "Saç Hizmetleri · Fiyat" },
  "friseur.services_title_1": { de: "Damen · Herren ·", en: "Ladies · Gents ·", tr: "Bayan · Bay ·" },
  "friseur.services_title_em": { de: "Kinder", en: "Kids", tr: "Çocuk" },
  "friseur.services_description": {
    de: "Von Trockenschnitt über Strähnen bis zur Keratin-Behandlung — alle Preise transparent. Endpreis je nach Haarlänge & Aufwand.",
    en: "From dry cut over highlights to keratin treatment — all prices transparent. Final price depends on hair length & effort.",
    tr: "Kuru kesimden röfleye ve keratin bakımına kadar — tüm fiyatlar şeffaf. Son fiyat saç uzunluğuna ve emek gerektiren duruma göre değişir.",
  },
  "friseur.card_1.title": { de: "Premium Pflege", en: "Premium Care", tr: "Premium Bakım" },
  "friseur.card_1.text": {
    de: "Hochwertige Produkte für glänzendes, gepflegtes Haar.",
    en: "Premium products for shiny, well-groomed hair.",
    tr: "Parlak ve bakımlı saçlar için kaliteli ürünler.",
  },
  "friseur.card_2.title": { de: "Handwerk", en: "Craft", tr: "Zanaat" },
  "friseur.card_2.text": {
    de: "Präzise Schnitte mit individueller Beratung.",
    en: "Precise cuts with personal consultation.",
    tr: "Kişisel danışmanlıkla hassas kesimler.",
  },
  "friseur.card_3.title": { de: "Telefonisch buchen", en: "Book by phone", tr: "Telefonla randevu" },
  "friseur.card_3.text": {
    de: "Friseur-Termine direkt unter +49 177 1815027 oder per WhatsApp.",
    en: "Hair appointments at +49 177 1815027 or via WhatsApp.",
    tr: "Kuaför randevuları +49 177 1815027 numarasından veya WhatsApp ile.",
  },
  "friseur.book_for_call": { de: "Anrufen", en: "Call", tr: "Ara" },
  "friseur.book_for_wa": { de: "WhatsApp", en: "WhatsApp", tr: "WhatsApp" },

  // Service categories
  "cat.angebote.title": { de: "Angebote & Pakete", en: "Offers & Packages", tr: "Teklifler & Paketler" },
  "cat.angebote.subtitle": { de: "Exklusive Behandlungs-Serien", en: "Exclusive treatment series", tr: "Özel bakım serileri" },
  "cat.angebote.badge": { de: "Featured", en: "Featured", tr: "Öne çıkan" },
  "cat.aesthetik.title": { de: "Ästhetik", en: "Aesthetics", tr: "Estetik" },
  "cat.aesthetik.subtitle": { de: "Unterspritzungen & Modellierung", en: "Injectables & contouring", tr: "Enjeksiyon & konturlama" },
  "cat.gesicht.title": { de: "Gesichtsbehandlungen", en: "Facials", tr: "Yüz Bakımı" },
  "cat.gesicht.subtitle": { de: "Pflegerituale für strahlende Haut", en: "Rituals for radiant skin", tr: "Işıltılı cilt için ritüeller" },
  "cat.koerper.title": { de: "Körperbehandlungen", en: "Body Treatments", tr: "Vücut Bakımları" },
  "cat.koerper.subtitle": { de: "Wohlbefinden von Kopf bis Fuß", en: "Wellness from head to toe", tr: "Baştan ayağa iyilik" },
  "cat.haar.title": { de: "Haarentfernung · Waxing", en: "Hair Removal · Waxing", tr: "Tüy Alma · Ağda" },
  "cat.haar.subtitle": { de: "Sanfte Enthaarung mit Premium-Wachs", en: "Gentle waxing with premium wax", tr: "Premium mumla nazik tüy alma" },
  "cat.naegel.title": { de: "Nägel, Hände & Füße", en: "Nails, Hands & Feet", tr: "Tırnak, El & Ayak" },
  "cat.naegel.subtitle": { de: "Maniküre · Pediküre · Modellage", en: "Manicure · Pedicure · Modeling", tr: "Manikür · Pedikür · Modelleme" },
  "cat.wimpern.title": { de: "Wimpern & Augenbrauen", en: "Lashes & Brows", tr: "Kirpik & Kaş" },
  "cat.wimpern.subtitle": { de: "Eyes that speak", en: "Eyes that speak", tr: "Konuşan gözler" },

  // Hair categories
  "hair_cat.damen.title": { de: "Damen", en: "Ladies", tr: "Bayan" },
  "hair_cat.damen.subtitle": {
    de: "Schnitt · Farbe · Pflege · Styling",
    en: "Cut · Color · Care · Styling",
    tr: "Kesim · Renk · Bakım · Stil",
  },
  "hair_cat.damen.badge": { de: "Signature", en: "Signature", tr: "İmza" },
  "hair_cat.herren.title": { de: "Herren", en: "Gents", tr: "Bay" },
  "hair_cat.herren.subtitle": { de: "Cut · Style · Routine", en: "Cut · Style · Routine", tr: "Kesim · Stil · Rutin" },
  "hair_cat.kinder.title": { de: "Kinder", en: "Kids", tr: "Çocuk" },
  "hair_cat.kinder.subtitle": {
    de: "Kleine Gäste, große Sorgfalt",
    en: "Small guests, great care",
    tr: "Küçük konuklar, büyük özen",
  },

  // Misc
  "aria.top": { de: "Nach oben", en: "Back to top", tr: "Yukarı" },
  "lang.switcher_label": { de: "Sprache", en: "Language", tr: "Dil" },
};
